import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ISocketMessage } from '@hosty-app/types';

import { CentrifugeBase, CentrifugeNextService } from './centrifugo-implementations';

@Injectable({ providedIn: 'root' })
export class CentrifugeService implements CentrifugeBase {
  #service = inject(CentrifugeNextService);

  // Retained for API compatibility with the version-poll in app.component.
  // The legacy v2 Centrifugo protocol has been retired backend-side, so a
  // single Centrifuge v5 client is always used.
  setVersionIsNew(_isNew: boolean): void {}

  listen(token: string, userId: number): Observable<ISocketMessage<any>> {
    return this.#service.listen(token, userId);
  }
}
